<template>
  <transition name="ai-slide-right">
    <aside v-if="open" class="ai-drawer" :class="{ docked: docked }" role="complementary">
      <header class="ai-drawer__header">
        <div class="ai-drawer__title">
          <i class="fa-solid fa-sparkles"></i>
          swiftChat
        </div>

        <button class="ai-icon-btn" @click="close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="ai-drawer__body">
        <k-tabstrip :selected="selectedTab"
                    @select="onSelect"
                    :tab-alignment="alignment"
                    :tabs="tabs"
                    class="ai-tabstrip">
          <template v-slot:UWGuides>
            <aiframe :url="uwGuidesUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 0" />
          </template>

          <template v-slot:docsum>
            <aiframe :url="docAnalysisUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 1" />
          </template>

          <template v-slot:pipeline>
            <aiframe :url="pipelineUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 2" />
          </template>

          <template v-slot:product_finder>
            <aiframe :url="productFinderUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 3" />
          </template>

          <template v-slot:genmarket>
            <comingsoon />
          </template>

          <template v-slot:recaloan>
            <comingsoon />
          </template>

          <template v-slot:sumaloan>
            <comingsoon />
          </template>
        </k-tabstrip>
      </div>
    </aside>
  </transition>
</template>

<script>
import { TabStrip } from "@progress/kendo-vue-layout";
import aiframe from "../ai.vue";
import comingsoon from "@/components/comingsoon.vue";

export default {
  name: "AIFlyoutDrawer",
  components: {
    "k-tabstrip": TabStrip,
    aiframe,
    comingsoon
  },
  props: {
    open: { type: Boolean, default: false },
    docked: { type: Boolean, default: false },
    selectedTab: { type: Number, default: 0 },
    alignment: { type: String, default: "start" },
    tabs: { type: Array, required: true },
    uwGuidesUrl: { type: String, required: true },
    docAnalysisUrl: { type: String, required: true },
    pipelineUrl: { type: String, required: true },
    productFinderUrl: { type: String, required: true },
    azureId: { type: String, required: true },
    userName: { type: String, required: true }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSelect(e) {
     this.$emit("tab-selected", e.selected)
    },
    onKeyDown(e) {
      if (e.key === "Escape") this.close();
    }
  },
  watch: {
    open(val) {
      if (val) window.addEventListener("keydown", this.onKeyDown);
      else window.removeEventListener("keydown", this.onKeyDown);
    }
  },
  mounted() {
    if (this.open) window.addEventListener("keydown", this.onKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
  }
};
</script>

<style scoped>
.ai-drawer {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ai-drawer__header {
  height: 64px;
  padding: 0 14px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: linear-gradient(#ffffff, #fbfcff);
}

.ai-drawer__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 900;
  font-size: 18px;
  color: #0f172a;
  letter-spacing: -0.2px;
}

.ai-icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 10px rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.72);
}

.ai-drawer__body {
  flex: 1;
  overflow: hidden;
}

.ai-tabstrip :deep(.k-tabstrip-items) {
  background: transparent !important;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.ai-tabstrip :deep(.k-item) {
  border: none !important;
  background: transparent !important;
  font-weight: 800;
  color: rgba(15, 23, 42, 0.58);
}

.ai-tabstrip :deep(.k-item.k-active) {
  color: #0f172a;
  border-bottom: 3px solid #2e6bdc !important;
}

.ai-tabstrip :deep(.k-content) {
  padding: 0 !important;
  height: calc(100vh - 64px);
  background: #fff !important;
}

.ai-slide-right-enter-active,
.ai-slide-right-leave-active {
  transition: transform 0.22s cubic-bezier(.22,1,.36,1);
}

.ai-slide-right-enter-from,
.ai-slide-right-leave-to {
  transform: translateX(100%);
}
</style>
